import React from 'react';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".custom-button {\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    transition: background-color 0.3s, transform 0.1s;\r\n  }\r\n  \r\n  .custom-button:hover {\r\n    transform: translateY(-1px);\r\n  }\r\n  \r\n  .custom-button:active {\r\n    transform: translateY(1px);\r\n  }\r\n  \r\n  .custom-button.primary {\r\n    background-color: #007bff;\r\n    color: white;\r\n  }\r\n  \r\n  .custom-button.secondary {\r\n    background-color: #6c757d; \r\n  }\r\n  \r\n  .custom-button.danger {\r\n    background-color: #dc3545;\r\n    color: white;\r\n  }\r\n  \r\n  .custom-button.info {\r\n    background-color: #17a2b8;\r\n    color: white;\r\n  }\r\n  \r\n  .custom-button.warning {\r\n    background-color: #ffc107;\r\n    color: black;\r\n  }\r\n  \r\n  .custom-button.small {\r\n    padding: 6px 12px;\r\n    font-size: 0.875rem;\r\n  }\r\n  \r\n  .custom-button.medium {\r\n    padding: 8px 16px;\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .custom-button.large {\r\n    padding: 10px 20px;\r\n    font-size: 1.125rem;\r\n  }";
styleInject(css_248z);

/**
 * Customizable and reusable Button component.
 * 
 * @param {Object} props - The component properties.
 * @param {React.ReactNode} props.children - The content of the button.
 * @param {Function} props.onClick - Function to be called when the button is clicked.
 * @param {('primary'|'secondary'|'danger'|'info'|'warning')} [props.variant='primary'] - The style variant of the button.
 * @param {('small'|'medium'|'large')} [props.size='medium'] - The size of the button.
 * @returns {React.ReactElement} A styled React button element.
 * 
 * @example
 * <Button onClick={() => console.log('Clicked')} variant="danger" size="large">
 *   Click Me
 * </Button>
 */
var Button = function Button(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  return /*#__PURE__*/React.createElement("button", {
    className: "custom-button ".concat(variant, " ").concat(size),
    onClick: onClick
  }, children);
};

export { Button as default };
